import { FC, forwardRef } from 'react';
import { DropdownMenuProps } from '@cld/dropdown-menu';
import { useApplicationWrapperContext } from '../../../context/applicationWrapper/ApplicationWrapper.context';
import { ApplicationsDropdownWrapper } from '../ApplicationsDropdownWrapper/ApplicationsDropdownWrapper';
import { applicationsInfo } from '../../../api/productList/ApplicationsInfoMap.const';
import { DefaultTriggerButtonProps } from '../../DefaultTriggerButton/DefaultTriggerButton';
import { AppId, ApplicationInfo } from '../../../ApplicationWrapper.types';
import { SingleApplicationInlineButton } from './SingleApplicationInlineButton';

export const useSelectedApplicationData = () => {
  const { selectedAppId } = useApplicationWrapperContext();

  return selectedAppId && (applicationsInfo as Record<AppId, ApplicationInfo>)[selectedAppId];
};

export const ApplicationsDropdownInlineButton = forwardRef<HTMLButtonElement, Partial<DefaultTriggerButtonProps>>((props, ref) => {
  return <SingleApplicationInlineButton ref={ref} {...props} />;
});

export const ApplicationsDropdownInlineTrigger: FC<React.PropsWithChildren<Partial<DropdownMenuProps>>> = (props) => (
  <ApplicationsDropdownWrapper placement="bottomLeft" trigger={<ApplicationsDropdownInlineButton />} {...props} />
);
